import React, { useState } from 'react';
import { useAppSelector } from '../../data/store';
import InfoIcon from '../../../../../ui/svg/common/info';
import FreeWithYourPurchasePopup from './free-with-your-purchase-popup';

const FreeWithYourPurchaseOverview = () => {

    const [popupVisible, setPopupVisible] = useState(false);

    const cartData = useAppSelector(store => store.root.cartData);
    const isInAppPurchase = useAppSelector(store => store.root.isInAppPurchase);

    const { freeWithPurchaseType, freeWithPurchaseValue } = cartData;

    const openPopup = () => {
        setPopupVisible(true);
    };

    return (
        (freeWithPurchaseType > 0) ?
        <div className="border-b pb-2 mb-4 text-gray-700 flex items-start">
            <div className="pr-2 flex-1 flex items-center">

                {
                    freeWithPurchaseType === 1 &&
                    <span className="mr-2 flex items-center">

                        { !isInAppPurchase && <a className="text-gray-700 no-underline mr-2" href="/support/waves-update-plan" title="">Waves Update Plan</a> }

                        { isInAppPurchase && <span className="mr-2">Waves Update Plan</span> }

                        <button type="button" onClick={ openPopup }><InfoIcon width="17px" color="#4a4a4a" classes="cursor-pointer" /></button>
                    </span>
                }

                {
                    freeWithPurchaseType === 2 &&
                    <span className="mr-2">Updates & Support</span>
                }
            </div>

            <div className="text-right whitespace-nowrap">
                <div className="text-xl font-bold text-gray-700">Free</div>

                {
                    freeWithPurchaseType === 1  &&
                    <div className="text-gray-500">Value <s>${ freeWithPurchaseValue }</s></div>
                }
            </div>

            { popupVisible && <FreeWithYourPurchasePopup setPopupVisible={ setPopupVisible }/> }
        </div>
        :
        <></>
    )
};

export default FreeWithYourPurchaseOverview;